/**
 * Required-upload (allowUpload2) ATC precheck.
 * Upload-success (imageUploaded) is distinct from a retained crop that can be retried.
 */
export const isRequiredUploadBlockingAtc = (allowUpload2: boolean, imageUploaded: boolean, hasRetryableLocalUpload: boolean): boolean => {
    return allowUpload2 && !imageUploaded && !hasRetryableLocalUpload;
};
